<template>
    <div>
        <table class="tbl-buddy mg-t-10">
            <thead>
              <tr>
                <th>
                    Овог, нэр
                    <feather @click="openFilterModal(1)" type="search" class="mg-l-5" role="button"></feather>
                </th>
                <th>
                    Домайн
                    <feather @click="openFilterModal(2)" type="search" class="mg-x-5" role="button"></feather>
                </th>
                <th>Buddy ажилтан</th>
                <th class="lh-1 pd-x-10 tx-12" v-for="b in $store.state.buddy.boxNames">{{ b.boxName }}</th>
              </tr>
            </thead>
            <tbody>
                <tr v-if="loading">
                    <td  :colspan="3+$store.state.buddy.boxNames.length">
                        <div class="alert alert-secondary mg-t-10" role="alert">
                        Түх хүлээнэ үү.
                        </div>
                    </td>
                </tr>
                <tr v-else-if="newbies.length<=0">
                    <td :colspan="3+$store.state.buddy.boxNames.length">
                        <div class="alert alert-secondary mg-t-10" role="alert">
                        Мэдээлэл хоосон байна.
                        </div>
                    </td>
                </tr>
                <tr @click="rowDetail(b)" :role="roleProp" v-else v-for="(b,bi) in newbies">
                    <td>
                        <div class="d-flex align-items-center mg-y-6">
                        <div class="mg-r-10" style="min-width: 40px;">
                            <img :src="`${b.newbie.avator}`" class="wd-40 rounded-20" />
                        </div>
                        <div>
                            <div class="d-flex align-items-start">
                                <div class="mg-t-3">{{ getFullName(b.newbie) }}</div>
                                <!-- {{ b.isActive }} -->
                                <!-- <div @click.stop="handleUserInfoModal(b.newbie.id)" role="button" class="tx-normal bd rounded bg-light mg-l-5 pd-x-10">
                                    <feather style="width: 18px; height: 18px" type="chevrons-right" class="mg-r-5"></feather>
                                    харах
                                </div> -->
                            </div>
                            <div class="tx-color-03 tx-normal lh-1 tx-12">
                                <template v-if="b.newbie.parentDepart!=undefined">{{b.newbie.parentDepart.name}} - </template>{{b.newbie.depart.name}}{{ b.newbie.position!=null && b.newbie.position!=''?' - ' + b.newbie.position : '' }}
                            </div>
                        </div>
                        </div>
                    </td>
                    <td>{{ b.newbie.loginName }}</td>
                    <td>{{ getFullName(b.buddy) }}</td>
                    <td v-for="bn in $store.state.buddy.boxNames">
                        <div :class="`tx-right ${b.boxesSummary.filter(x=>x.code==bn.code)[0]['progress']>0?'':'tx-normal tx-color-03'}`" v-if="b.boxesSummary.filter(x=>x.code==bn.code).length">
                            {{ b.boxesSummary.filter(x=>x.code==bn.code)[0]['progress'].toFixed(1) }}<sup>%</sup>
                        </div>
                    </td>
                </tr>
            </tbody>
        </table>

        <div class="d-flex justify-content-end mg-t-10 pgr-outer">
            <b-pagination
              v-model="pager.currentPage"
              :total-rows="newbiesCount"
              :per-page="pager.perPage"
              @change="pageChanged"
              first-number
              last-number
              align="center"
            ></b-pagination>
          </div>

        <b-modal v-model="objFilterModal.modal" title="Хайх" centered>
            <div v-if="objFilterModal.mode==1">
                <div class="form-group">
                <label class="tx-10 tx-uppercase tx-medium tx-spacing-1 mg-b-5 tx-color-03">Овог</label>
                <input v-model="filterModel.lastName" type="text" class="form-control" placeholder="Овог оруулна уу">
                </div>
                <div class="form-group">
                <label class="tx-10 tx-uppercase tx-medium tx-spacing-1 mg-b-5 tx-color-03">Нэр</label>
                <input v-model="filterModel.firstName" type="text" class="form-control" placeholder="Нэр оруулна уу">
                </div>
            </div>
            <div v-else-if="objFilterModal.mode==2">
                <div class="form-group">
                <label class="tx-10 tx-uppercase tx-medium tx-spacing-1 mg-b-5 tx-color-03">Домайн</label>
                <input v-model="filterModel.loginName" type="text" class="form-control" placeholder="Домайн оруулна уу">
                </div>
            </div>

            
            <template #modal-footer>
                <div class="btn-group">
                <button @click="objFilterModal.modal= false;" type="button" class="btn btn-white" data-dismiss="modal">Болих</button>
                <button @click="objFilterModal.modal= false; init()" type="button" class="btn btn-primary">Хайх</button>
                </div>
            </template>
        </b-modal>
    </div>
</template>
<script>
import { request } from "@/api/all";
import { mapActions } from "vuex";

export default {
    props:{
        filterModelProp:{
            type: Object,
            default: () => {}
        },
        roleProp:{
            type: String,
            default: () => ""
        }
    },
    data(){
        return {
            loading: false,
            newbies: [],
            filterModel:{
                departId: null,
                firstName: null,
                lastName: null,
                loginName: null,
                startDate: null,
                endDate: null
            },
            pager:{
                perPage:10,
                currentPage: 1
            },
            newbiesCount: null,
            objFilterModal:{
                mode: null,
                modal: false
            },
        }
    },
    mounted(){
        this.initBefore();
    },
    methods:{
        ...mapActions(["handleUserInfoModal"]),
        pageChanged(e){
            this.pager.currentPage = e;
            this.init();
        },
        openFilterModal(mode){
            this.objFilterModal.mode= mode;
            this.objFilterModal.modal= true;
        },
        rowDetail(b){
            if(this.roleProp=="button"){
                this.$emit('on-detail', b);
            }
        },
        getFullName(b){
            let rv=b.firstName.toUpperCase();
            if(b.lastName!=undefined && b.lastName!=null && b.lastName!='' && b.lastName.length){
                rv= b.lastName.charAt(0).toUpperCase() + '. ' +b.firstName;
            }
            return rv;
        },
        initBefore(){
            // console.log('initBefore fired');
            if(this.filterModelProp!=undefined && this.filterModelProp!=null){
                // console.log('w1', this.filterModelProp);
                if(this.filterModelProp.departId!=undefined){
                    // console.log('w2', this.filterModelProp.departId);
                    this.filterModel.departId= this.filterModelProp.departId;
                    // console.log('w2_1', this.filterModel.departId);
                } else if(this.filterModelProp.departId==null){
                    // console.log('w3');
                    this.filterModel.departId= null;
                }

                if(this.filterModelProp.startDate!=undefined){
                    this.filterModel.startDate= this.filterModelProp.startDate;
                }else{
                    this.filterModel.startDate= null;
                }

                if(this.filterModelProp.endDate!=undefined){
                    this.filterModel.endDate= this.filterModelProp.endDate;
                }else{
                    this.filterModel.endDate= null;
                }

                if(this.filterModelProp.getDisabledNewbies!=undefined){
                    this.filterModel={
                        getDisabledNewbies: true,
                        newbieStatusCode: 'newbie'
                    };
                }
                if(this.filterModelProp.matchDueDate!=undefined){
                    this.filterModel={
                        matchDueDate: this.filterModelProp.matchDueDate,
                    };
                }

                // if(this.filterModelProp.locTypeId!=undefined){
                //   this.filterModel.locTypeId= this.filterModelProp.locTypeId;
                // }
            }
            
            this.init();
        },
        init(){
            // console.log('w2_2', this.filterModel);
            this.loading= true;
            this.newbies= [];
            this.toggleBodyClass("addClass", "dynamic-locker");
            // console.log('skip', (this.pager.currentPage - 1) * this.pager.perPage, this.pager.perPage);
            request({
                api: { method: "POST", url: "buddy/admin/getNewbies" },
                data: {
                    pager:{
                        skip: (this.pager.currentPage - 1) * this.pager.perPage,
                        size: this.pager.perPage,
                    },
                    filter: this.filterModel
                },
                store: this.$store,
            }).then((res) => {
                this.loading= false;
                this.toggleBodyClass("removeClass", "dynamic-locker");
                if(res!=false) {
                    // console.log('res buddy/admin/getNewbies', res.data);
                    this.newbiesCount= res.data.count;
                    this.newbies= res.data.list;
                }
            });
        },
        toggleBodyClass(addRemoveClass, className) {
            const el = document.body;

            if (addRemoveClass === "addClass") {
                el.classList.add(className);
            } else {
                el.classList.remove(className);
            }
        },
    }
}
</script>